import React from 'react';

interface StatCardProps {
  title: string;
  value: number;
  icon: JSX.Element;
  onClick?: () => void;
  isLoading?: boolean;
}

const StatCard = ({ title, value, icon, onClick, isLoading = false }: StatCardProps) => {
  return (
    <div 
      className="bg-white rounded-lg shadow p-4 sm:p-6 hover:shadow-lg transition-shadow cursor-pointer"
      onClick={onClick}
    >
      <div className="flex items-center">
        <div className="p-3 bg-primary bg-opacity-10 rounded-full">
          {icon}
        </div>
        <div className="ml-4">
          <h2 className="text-xs sm:text-sm font-medium text-gray-500">{title}</h2>
          <p className="text-xl sm:text-2xl font-semibold text-dark">
            {isLoading ? (
              <span className="inline-block w-16 h-8 bg-gray-200 animate-pulse rounded"></span>
            ) : (
              value
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default StatCard; 